export enum DocumentDetailsStatus {
    Viewable,
    RequiresAction,
    Completed,
    PendingPreparation,
    AwaitingCoSigners = 4,
}

export const DocumentDetailsStatusOptions = {
    [DocumentDetailsStatus.Viewable]: 'Viewable',
    [DocumentDetailsStatus.RequiresAction]: 'Requires Action',
    [DocumentDetailsStatus.Completed]: 'Completed',
    [DocumentDetailsStatus.PendingPreparation]: 'Pending Preparation',
    [DocumentDetailsStatus.AwaitingCoSigners]: 'Awaiting co-owners',
};